// Haegoziya — JS entry. Load behavior modules.
import './modules/nav.js';
import './modules/newsletter.js';
import './modules/cart-fragments.js';
import './modules/cart-count.js';
import './modules/wishlist.js';
import './modules/quick-add.js';
import './modules/quickview.js';
import './modules/cart-drawer.js';
import './modules/hero-slider.js';
import './modules/cart-page.js';
import './modules/offers-filter.js';
import './modules/cats-carousel.js';
import './modules/checkout-carousel.js';
import './modules/promo-countdown.js';
import './modules/sale-countdown.js';
import './modules/recipes-carousel.js';
import './modules/recipe-search.js';
import './modules/product-carousel.js';
import './modules/hero-categories.js';
import './modules/contact-form.js';
import './modules/product-detail.js';
import './modules/compare.js';
import './modules/wc-notices.js';
import './modules/tier-chips.js';
import './modules/shorts-modal.js';
import './modules/bundles.js';
import './modules/infinite-scroll.js';
import './modules/farmers-carousel.js';
import './modules/account-auth.js';
import './modules/contact-widget.js';

document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');
